import React, { forwardRef, useState, useImperativeHandle, useEffect, useRef } from 'react'
import { InputBase, Divider } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import DirectionsIcon from '@mui/icons-material/Send';
import FaceIcon from '@mui/icons-material/Face';
import CloseIcon from '@mui/icons-material/Close';
import MicIcon from '@mui/icons-material/Mic';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import Paper from '@mui/material/Paper';
import ReactMarkdown from "react-markdown";
import axiosInstance from '../util/AxiosUtil';
import { useLocation } from 'react-router-dom';

import DracoParamMain from '../context/draco_view_params/DracoParamMain';                   //메인

import DracoProductPrdt from '../context/draco_view_params/DracoProductPrdt';               //제품관리

import DracoParamSalesRequest from '../context/draco_view_params/DracoParamSalesRequest';   //업무요청서 등록

import '../../assets/css/DracoUX.css';

const DracoUX = forwardRef((props, ref) => {

    let animationFrameId = null;

    const location = useLocation();

    const uuid = Date.now().toString(36) + Math.random().toString(36).substring(2);

    const [open, setOpen] = useState(false);        

    const [value, setValue] = useState("");

    const inputRef = useRef();

    const scrollRef = useRef();

    const containerRef = useRef(null);

    const divRef = useRef(null);        

    const dragging = useRef(false);

    const startX = useRef(0);
    const startY = useRef(0);

    const offsetX = useRef(0);
    const offsetY = useRef(0);

    const recognitionRef = useRef(null);      
    
    const [isListening, setIsListening] = useState(false);    

    const [chatList, setChatList] = useState([
        {type: 'ai', message: '안녕하세요, 무엇을 도와 드릴까요?'}
    ]);

    const handleActive = () => {        
        setOpen(true);  
    };

    const handleOpen = () => {        
        setOpen(!open);  
    };
    
    const handleAddMessage = (type, message) => {        

        if (message !== ""){

            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;

            setChatList(prev => [ ...prev,
                { type: type, message: message }
            ]);

            if (type === "user"){
                callApi(message)
            }            

            setValue(""); // 입력창 비우기            
        }
    }   

    const handleMouseDown = (e) => {
        const rect = divRef.current.getBoundingClientRect();
        dragging.current = true;

        offsetX.current = e.clientX - rect.left;
        offsetY.current = e.clientY - rect.top;

        if (startX.current === 0 && startY.current === 0){
            startX.current = rect.left;
            startY.current = rect.top;            
        }   
    };

    const handleMouseMove = (e) => {
        if (!dragging.current) return;      
        
        if (animationFrameId) cancelAnimationFrame(animationFrameId);

        animationFrameId = requestAnimationFrame(() => {
            const newX = e.clientX - offsetX.current - startX.current;
            const newY = e.clientY - offsetY.current - startY.current + window.scrollY;

            containerRef.current.style.transform = `translate(${newX}px, ${newY}px)`;
        });        
    };

    const handleMouseUp = () => {    
        dragging.current = false;
    };

    const windowMouseMove = (e) => {
        handleMouseMove(e);
    }

    const close = () => {  
        setOpen(false);
    }

    // 음성 녹음 시작작
    const startSTT = (autoApiCall = false) => {

        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    
        if (!SpeechRecognition) {
          alert('이 브라우저는 STT를 지원하지 않아요 😢 (Chrome에서 사용해주세요)');
          return;
        }
    
        const recognition = new SpeechRecognition();
        recognition.lang = 'ko-KR';
        recognition.interimResults = false;
        recognition.continuous = true; // 한 문장만 인식
    
        recognition.onresult = (event) => {
          const text = event.results[0][0].transcript;          
          if (text){
            if (autoApiCall){
                handleAddMessage("user", text);
            }else{
                setValue(text);
            }
            
            console.log('🎙️ 인식된 텍스트:', text);          
          }                    
        };
             
        recognition.onerror = (event) => {
          console.log('STT 에러:', event.error);
        };              
    
        recognitionRef.current = recognition;        
        setIsListening(true);
        recognition.start();        
    };
    
    // 음성 녹음 종료
    const stopSTT = () => {
        if (recognitionRef.current) {
            recognitionRef.current.stop();
            setIsListening(false);            
        }       
    };

    // API 서버 질의의    )
    const callApi = (message) => {    
        
        let pageName = "";
        let pageDesc = "";
        let pageTagList = "[]";
        let fewShot = "";

        //화면별 파라메터 정보 가져오기
        if (location.pathname === "/"){
            pageName = "메인";
            pageDesc = DracoParamMain.pageDesc;
            pageTagList = JSON.stringify(DracoParamMain.tags);     
            fewShot = DracoParamMain.fewShot;       
        }else if (location.pathname === "/product/prdt"){
            pageName = "제품관리리";
            pageDesc = DracoProductPrdt.pageDesc;
            pageTagList = JSON.stringify(DracoProductPrdt.tags);            
            fewShot = DracoProductPrdt.fewShot;
        }else if (location.pathname === "/sales/request"){
            pageName = "업무요청서 등록";
            pageDesc = DracoParamSalesRequest.pageDesc;
            pageTagList = JSON.stringify(DracoParamSalesRequest.tags);            
            fewShot = DracoParamSalesRequest.fewShot;
        }

        axiosInstance.post('/draco/web/ctl', {"uuid": uuid, "question": message, "location": location, "pageName": pageName, "pageDesc": pageDesc, "pageTagList": pageTagList, "fewShot": fewShot}).then((Response)=>{            

            if (Response){
                if (Response.data){
                    try {                        
                        //화면 제어 명령어 전송                        
                        const jsonObject = Response.data
                        const commands = jsonObject["command"];
                        
                        commands.forEach(command => {   
                            if (command.cd === "MV"){
                                //메뉴 이동                                
                                localStorage.setItem('lastParentMenuIndex', command.MenuIndex);
                                localStorage.setItem('lastUrl', command.url);
                                window.location.href = command.url;  
                                return;     
                            }
                        });

                        props.reciveCommand(commands);                 

                        handleAddMessage('ai', '처리 되었습니다.');                        
                    } catch (e) {
                        handleAddMessage('ai', Response.data);
                        handleActive();
                    }
                }
            }else{
                console.log("시스템 오류 입니다. 관리자에게 문의 하세요.")                
            }
        });      
    }
    
    //부모 컴포넌트에서 호출 할 수 있는 함수 정의
    useImperativeHandle(ref, () => ({
        handleOpen, handleActive, handleAddMessage, startSTT, stopSTT
    }))

    useEffect(() => {        
        inputRef.current && inputRef.current.focus();
        window.addEventListener('mousemove', windowMouseMove);
    });    

    useEffect(() => {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }, [chatList]);

    return (
        <div className="chat" ref={containerRef} style={{ display: open ? 'block' : 'none'}}>
            <div className="chat-title" ref={divRef} onMouseDown={handleMouseDown} onMouseMove={handleMouseMove} onMouseUp={handleMouseUp}>
                <div className="chat-title-text">Draco UX</div>
                <div className="chat-title-close" onClick={close}>
                    <CloseIcon/>
                </div>                
            </div>
            <div className="chat-content" ref={scrollRef}>

                {
                    chatList.map((item, index) => {  
                    
                        if (item.type === 'ai') {
                            return <div key={index} style={{paddingTop:"10px", paddingBottom:"10px"}}>
                                <div className="chat-ai">
                                    <IconButton className="chat-icon-ai" color="primary" sx={{ p: '10px' }} aria-label="directions">
                                        <SupportAgentIcon />
                                    </IconButton>
                                    <div className="chat-ai-span"><ReactMarkdown>{item.message}</ReactMarkdown></div>
                                </div>
                            </div>
                        }else {
                            return <div key={index}>
                                <div key={index} className="chat-user">                                
                                    <IconButton className="chat-icon-user" color="primary" sx={{ p: '10px' }} aria-label="directions">
                                        <FaceIcon />
                                    </IconButton>                                                        
                                    <div className="chat-user-span">{item.message}</div>
                                </div>
                            </div>
                        }
                    }
                )}                                       
            </div>
            <div className="chat-fotter">
                <Paper component="form" sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: "100%" }}>
                    <InputBase sx={{ ml: 1, flex: 1 }} inputRef={inputRef} placeholder="메세지 입력" inputProps={{ 'aria-label': '메세지 입력' }} value={value} onChange={e=>setValue(e.target.value)} onKeyDown={e => {
                        if (e.key === 'Enter' && !e.shiftKey) {
                            e.preventDefault();
                            handleAddMessage('user', value);
                        }
                    }} />                
                    <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                    <IconButton className={isListening  ? "listening" : ""}
                                color="primary" 
                                sx={{ p: '10px' }} 
                                aria-label="directions"
                                onMouseDown={startSTT}
                                onMouseUp={stopSTT}
                                onTouchStart={startSTT}
                                onTouchEnd={stopSTT}>
                        <MicIcon />
                    </IconButton>
                    <IconButton color="primary" sx={{ p: '10px' }} aria-label="directions" onClick={e=>handleAddMessage('user', value)}>
                        <DirectionsIcon />
                    </IconButton>
                </Paper>
            </div>
        </div>        
    )
});

export default DracoUX